<template>
  <div v-if="show" ref="chart" class="chart-content">
    <div class="chart-title">{{name}}</div>
    <i v-if="isShowCloseBtn" class="iconfont icon-guanbi_o chart-close" @click='close($event)' :class="{active: name !== ''}"></i>
    <el-table ref="myChart" :data="tableData" :cell-style="{ color: '#fff' }" style="margin-top:10px" :header-cell-style="{ color: '#d5dd2d' ,backgroundColor:'#063692'}" :row-class-name="tableRowClassName">>
      <el-table-column prop="name" label="项目名称"></el-table-column>
      <el-table-column prop="chargeValue" label="可计费"></el-table-column>
      <el-table-column prop="notChargeValue" label="不可计费"></el-table-column>
      <el-table-column prop="amount" label="合计"></el-table-column>

    </el-table>
  </div>
</template>


<script>
import elementResizeDetectorMaker from "element-resize-detector";
import { EleResize } from '@/utils/EleResize.js'
import {
  GetPurchaseComposeDetailsByCharge
} from '@/api'
export default ({
  data () {
    return {
      myChart: null,
      option: {},
      tableData: [],
      show: true,
      setInterval: null
    };
  },
  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    },
    isShowCloseBtn: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  //监听beforinfo值的变化
  watch: {
    data: {
      handler (newVal, oldVal) {
        this.option.series[0].data = newVal
        if (!this.myChart) {
          this.myChart = this.$echarts.init(this.$refs['myChart'])
        }
        this.myChart.setOption(this.option);
      },
      deep: true
    }
  },
  methods: {
    // 获取列表
    getData () {
      GetPurchaseComposeDetailsByCharge({})
        .then(res => {
          this.tableData = res.returnData
          // console.log(this.data)
          // this.myChart.setOption(this.option);
          // this.init(res.returnData)
        })
    },
    init () {
      // this.myChart.setOption(this.option);

      // // 随窗口的大小变化自适应
      // window.addEventListener("resize", function () {
      //   myChart.resize();
      // });
      //  随外层div的大小变化自适应
      // const _this = this
      // let erd = elementResizeDetectorMaker();
      // erd.listenTo(this.$refs.myChart, (e) => {
      //   _this.$nextTick(() => {
      //     // _this.myChart.resize();

      //   })
      // })
      EleResize.on(this.$refs['chart'], (e) => {
        // console.log(e.target.innerHeight, 'e')
        // console.log(this.$refs['chart'].parentNode, 'this.$refs')
        
        this.$emit('SizeChange', e.target.innerWidth, e.target.innerHeight, this.$refs['chart'].parentNode.id)
      })
    },
    close (e) {
      this.show = false
      // 给drag+index div 追加隐藏样式 e.path[2] = drag2 非动态获取
      e.target.parentNode.parentNode.classList.add('hide')
      //修改state=0
      this.$emit('StateChange', 0, e.target.parentNode.parentNode.id);
    }, tableRowClassName ({ row, rowIndex }) {

      if (rowIndex % 2 == 0) {
        // console.log(111, rowIndex, "rowIndex");
        return 'warning-row';
      } else if (rowIndex === 3) {
        // console.log(222, rowIndex, "rowIndex");
        return 'success-row';
      } else {
        return 'success-row';
      }
      return '';
    }
  },
  mounted () {
    this.getData();
    this.init()
    let that = this
    this.setInterval = setInterval(function () {
      that.getData();
    }, 5 * 60 * 1000)
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
  },
  beforeDestroy () {
    clearInterval(this.setInterval)
  },
})
</script>
<style scoped lang="scss">
.chart-content {
  width: calc(100% - 20px);
  height: 100%;
  padding: 0 10px 10px;
  // display: flex;
  .chart {
    width: 100%;
    height: 100%;
    // position: absolute;
  }
  .chart-title {
    color: #fff;
    font-size: 18px;
    font-weight: bold;
  }
  .chart-close {
    height: 20px;
    width: 20px;
    color: rgb(255, 255, 255);
    margin-left: 20px;
    float: right;
    // margin-top: -19px;
    &.active {
      margin-top: -19px;
    }
  }
}
// .el-table {
//   border-right: 1px solid black;
//   border-bottom: 1px solid black;
// }
// .el-table th {
//   border: 1px solid black;
// }

// .el-table td {
//   border: 1px solid black;
//   color: black;
// }

// .el-table__empty-block {
//   border-left: 1px solid black;
//   border-top: 1px solid black;
// }
// .el-table {
//   color: black;
// }

// .user_skills {
//   width: 50%;
//   margin: auto;
// }
/*最外层透明*/
::v-deep .el-table,
::v-deep .el-table__expanded-cell {
  background-color: transparent !important;
}
// /* 表格内背景颜色 */
// ::v-deep .el-table th,
// ::v-deep .el-table tr,
// ::v-deep .el-table td {
//   background-color: transparent !important;
// }
::v-deep .el-table__header-wrapper {
  margin-bottom: 0px !important;
}
/deep/ .el-table tbody tr {
  pointer-events: none; // 去掉选中高亮
}
/deep/ .el-table__cell {
  border: 0px !important; // 去掉表格内下划线
}
/deep/ .el-table__body {
  border-top: 0px !important; //删除表头下横线
}
// table 斑马颜色
/deep/ .el-table .warning-row {
  background: #01014d; // rgb(99, 130, 225);
}
// table 表格 index =1 的颜色
/deep/.el-table .success-row {
  background: #1e377b;
}
</style>
